/**
 * Formate un nombre de manière compacte pour l'affichage
 * Exemples: 1234 -> "1.2k", 1000000 -> "1M"
 */
export const formatViewCount = (count: number): string => {
  if (count === 0) return '0';
  
  if (count < 1000) {
    return count.toString();
  }
  
  if (count < 1000000) {
    const k = count / 1000;
    return k % 1 === 0 ? `${k}k` : `${k.toFixed(1)}k`;
  }
  
  if (count < 1000000000) {
    const m = count / 1000000;
    return m % 1 === 0 ? `${m}M` : `${m.toFixed(1)}M`;
  }
  
  const b = count / 1000000000;
  return b % 1 === 0 ? `${b}B` : `${b.toFixed(1)}B`;
};

/**
 * Formate un temps relatif (ex: "il y a 2h")
 */
export const formatTimeAgo = (date: Date): string => {
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  
  if (diffInMinutes < 1) return 'À l\'instant';
  if (diffInMinutes < 60) return `il y a ${diffInMinutes}m`;
  
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return `il y a ${diffInHours}h`;
  
  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) return `il y a ${diffInDays}j`;
  
  const diffInWeeks = Math.floor(diffInDays / 7);
  if (diffInWeeks < 4) return `il y a ${diffInWeeks}sem`;
  
  return date.toLocaleDateString('fr-FR', { 
    day: 'numeric', 
    month: 'short' 
  });
};
